module.exports = __webpack_public_path__ + "8d65b72a837a8b22e703a025eada8fff.svg";